import React from 'react';
import { LoaderCircle } from 'lucide-react';

export type SpinnerSize = 'xs' | 'sm' | 'md' | 'lg';
export type SpinnerVariant = 'neutral' | 'primary' | 'muted';

interface SpinnerProps {
  size?: SpinnerSize;
  variant?: SpinnerVariant;
  className?: string;
  ariaLabel?: string;
}

export function Spinner({
  size = 'sm',
  variant = 'neutral',
  className,
  ariaLabel = 'Loading...'
}: SpinnerProps) {
  const sizePx: Record<SpinnerSize, number> = { xs: 14, sm: 16, md: 20, lg: 24 };
  const variantClass: Record<SpinnerVariant, string> = {
    neutral: 'text-current',
    primary: 'text-primary',
    muted: 'text-muted-foreground'
  };

  const rootClass = [
    'inline-flex items-center justify-center',
    variantClass[variant],
    className
  ].filter(Boolean).join(' ');

  const px = sizePx[size];

  return (
    <span role="status" aria-live="polite" aria-label={ariaLabel} className={rootClass}>
      <LoaderCircle className="animate-spin" width={px} height={px} aria-hidden />
      <span className="sr-only">{ariaLabel}</span>
    </span>
  );
}

export default Spinner;
